/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ShipPlanningOverviewSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type ShipPlanningOverviewSubscription = {
  __typename?: 'Subscription',
  shipPlanning: {
    __typename?: 'ShipPlanningDTO',
    ship: {
      __typename?: 'ShipShipPlanningDTO',
      id: number,
      name: string,
      sequenceNumber?: number | null,
      lastContact?: number | null,
      planningNotes?: string | null,
      operator?: {
        __typename?: 'RelationShipPlanningDTO',
        id: number,
        isApplicationRelation: boolean
      } | null,
      position?: {
        __typename?: 'ActualShipPositionShipPlanningDTO',
        id: number,
        latitude: number,
        longitude: number,
        course: number,
        timestamp?: number | null,
        location?: string | null,
        locationEntered?: number | null
      } | null,
      nextCall?: {
        __typename?: 'NextShipCallShipPlanningDTO',
        pta: number,
        eta?: number | null,
        ata?: number | null,
        ptd: number,
        etd?: number | null,
        atd?: number | null,
        etso?: number | null,
        eteo?: number | null,
        atso?: number | null,
        ateo?: number | null,
        etfm?: number | null,
        etlm?: number | null,
        atfm?: number | null,
        atlm?: number | null,
        atn?: number | null,
        dtn?: number | null,
        systemAta?: number | null,
        systemAtd?: number | null,
        systemEta?: number | null,
        systemEtd?: number | null
      } | null
    },
    salesCharters: Array<{
      __typename?: 'SalesCharterShipPlanningDTO',
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      internalNotes?: string | null,
      subtype: Types.CharterSubtype,
      validFrom?: number | null,
      validUntil?: number | null,
      status: {
        __typename?: 'SalesCharterStatusType',
        name: Types.SalesCharterStatus,
        color: string,
        languageKeyPrefix: string
      },
      salesCharterStatusChanges: Array<{
        __typename?: 'SalesCharterStatusChangeShipPlanningDTO',
        id: number,
        createdOn: number,
        notes?: string | null,
        status: {
          __typename?: 'SalesCharterStatusType',
          name: Types.SalesCharterStatus,
          color: string,
          languageKeyPrefix: string
        },
        appliedBy: {
          __typename?: 'StatusChangeAccountDetailsShipPlanningDTO',
          id: number,
          username: string,
          displayName?: string | null
        }
      }>,
      creditor: {
        __typename?: 'RelationShipPlanningDTO',
        id: number,
        name: string,
        isApplicationRelation: boolean
      },
      cargos: Array<{
        __typename?: 'CargoShipPlanningDTO',
        id: number,
        cargoNumber?: string | null,
        nominatedWeight?: number | null,
        weight?: number | null,
        isWeightPrimary: boolean,
        volume?: number | null,
        isVolumePrimary: boolean,
        waterLevelOptimised: boolean,
        isHoseRentalRequired: boolean,
        isInhibitedProduct: boolean,
        isNitrogenBlanketingRequired: boolean,
        isNitrogenPurgingRequired: boolean,
        isTemperatureControlRequired: boolean,
        isCleaningRequired: boolean,
        lastStatusChange?: {
          __typename?: 'StatusChangeShipPlanningDTO',
          id: number,
          actualTime?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          callEstimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp: number,
          appliedBy: string,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'StatusWithSuccessiveStatusesShipPlanningDTO',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatusShipPlanningDTO',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescriptionShipPlanningDTO',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules: Array<{
              __typename?: 'StatusRuleShipPlanningDTO',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              type: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'StatusRuleTargetStatusShipPlanningDTO',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatusShipPlanningDTO',
                  enabled: boolean
                } | null
              }
            }>,
            confirmMessages?: {
              __typename?: 'LanguageDescriptionShipPlanningDTO',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            successiveStatuses: Array<{
              __typename?: 'StatusShipPlanningDTO',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatusShipPlanningDTO',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescriptionShipPlanningDTO',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules: Array<{
                __typename?: 'StatusRuleShipPlanningDTO',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                type: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'StatusRuleTargetStatusShipPlanningDTO',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatusShipPlanningDTO',
                    enabled: boolean
                  } | null
                }
              }>,
              confirmMessages?: {
                __typename?: 'LanguageDescriptionShipPlanningDTO',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null
            }>
          },
          supplier?: {
            __typename?: 'RelationShipPlanningDTO',
            id: number,
            name: string
          } | null
        } | null,
        product: {
          __typename?: 'CargoProductShipPlanningDTO',
          id: number,
          name: string
        },
        actions: Array<{
          __typename?: 'CargoActionShipPlanningDTO',
          id: number,
          type: Types.CallType,
          weight?: number | null,
          volume?: number | null,
          start?: number | null,
          call?: {
            __typename?: 'CargoActionCallShipPlanningDTO',
            id: number,
            eta?: number | null,
            etso?: number | null,
            eteo?: number | null,
            etd?: number | null
          } | null,
          location: {
            __typename?: 'LocationShipPlanningDTO',
            id: number,
            type: Types.LocationType
          }
        }>,
        firstLoadingAction?: {
          __typename?: 'DetailedCargoActionShipPlanningDTO',
          displayAsWindow?: boolean | null,
          start?: number | null,
          end?: number | null,
          simulatedTimestamp: boolean,
          terminalPlanningNotes?: string | null,
          connectingVisitNotes?: string | null,
          weight?: number | null,
          volume?: number | null,
          shipToShip?: boolean | null,
          id: number,
          location: {
            __typename?: 'LocationShipPlanningDTO',
            lastTerminalContactDate?: number | null,
            id: number,
            description: string,
            type: Types.LocationType,
            locationGroups?: Array<{
              __typename?: 'LocationShipPlanningDTO',
              id: number,
              description: string,
              type: Types.LocationType
            }> | null
          },
          measurements: {
            __typename?: 'CargoMeasurementsShipPlanningDTO',
            locationWeight?: number | null,
            locationWeightUnit?: Types.WeightUnit | null,
            locationVolume?: number | null,
            skipperWeightUnit?: Types.WeightUnit | null,
            skipperWeight?: number | null,
            skipperVolume?: number | null,
            locationVolumeUnit?: Types.VolumeUnit | null,
            skipperVolumeUnit?: Types.VolumeUnit | null
          },
          connectingShipPortVisit?: {
            __typename?: 'ConnectingShipPortVisitShipPlanningDTO',
            id: number,
            lastUpdateFromAgentOn?: number | null,
            from?: number | null,
            until?: number | null,
            ship: {
              __typename?: 'ConnectingShipPortVisitShipShipPlanningDTO',
              id: number,
              name: string,
              lastContact?: number | null
            },
            agent?: {
              __typename?: 'ConnectingShipPortVisitAgentDTO',
              id: number,
              name: string
            } | null,
            location: {
              __typename?: 'ConnectingVisitLocationDTO',
              id: number,
              description: string,
              locationGroups?: Array<{
                __typename?: 'ConnectingVisitLocationDTO',
                id: number,
                description: string,
                type?: Types.LocationType | null
              }> | null
            }
          } | null,
          connectingShipBerthing?: {
            __typename?: 'ConnectingShipBerthingDTO',
            id: number,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null,
            location?: {
              __typename?: 'ConnectingVisitLocationDTO',
              id: number,
              description: string,
              locationGroups?: Array<{
                __typename?: 'ConnectingVisitLocationDTO',
                id: number,
                description: string,
                type?: Types.LocationType | null
              }> | null
            } | null
          } | null
        } | null,
        lastDischargingAction?: {
          __typename?: 'DetailedCargoActionShipPlanningDTO',
          displayAsWindow?: boolean | null,
          start?: number | null,
          end?: number | null,
          terminalPlanningNotes?: string | null,
          connectingVisitNotes?: string | null,
          simulatedTimestamp: boolean,
          shipToShip?: boolean | null,
          id: number,
          location: {
            __typename?: 'LocationShipPlanningDTO',
            lastTerminalContactDate?: number | null,
            id: number,
            description: string,
            type: Types.LocationType,
            locationGroups?: Array<{
              __typename?: 'LocationShipPlanningDTO',
              id: number,
              description: string,
              type: Types.LocationType
            }> | null
          },
          connectingShipPortVisit?: {
            __typename?: 'ConnectingShipPortVisitShipPlanningDTO',
            id: number,
            lastUpdateFromAgentOn?: number | null,
            from?: number | null,
            until?: number | null,
            ship: {
              __typename?: 'ConnectingShipPortVisitShipShipPlanningDTO',
              id: number,
              name: string,
              lastContact?: number | null
            },
            agent?: {
              __typename?: 'ConnectingShipPortVisitAgentDTO',
              id: number,
              name: string
            } | null,
            location: {
              __typename?: 'ConnectingVisitLocationDTO',
              id: number,
              description: string,
              locationGroups?: Array<{
                __typename?: 'ConnectingVisitLocationDTO',
                id: number,
                description: string,
                type?: Types.LocationType | null
              }> | null
            }
          } | null,
          connectingShipBerthing?: {
            __typename?: 'ConnectingShipBerthingDTO',
            id: number,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null,
            location?: {
              __typename?: 'ConnectingVisitLocationDTO',
              id: number,
              description: string,
              locationGroups?: Array<{
                __typename?: 'ConnectingVisitLocationDTO',
                id: number,
                description: string,
                type?: Types.LocationType | null
              }> | null
            } | null
          } | null
        } | null
      }>,
      shipNominationStatusChanges: Array<{
        __typename?: 'ShipNominationStatusChangeShipPlanningDTO',
        id: number,
        createdOn: number,
        notes?: string | null,
        status: {
          __typename?: 'ShipNominationStatusType',
          name: Types.ShipNominationStatus,
          color: string,
          languageKeyPrefix: string
        },
        appliedBy: {
          __typename?: 'StatusChangeAccountDetailsShipPlanningDTO',
          id: number,
          username: string,
          displayName?: string | null
        },
        ship: {
          __typename?: 'ShipNominationStatusChangeShipShipPlanningDTO',
          id: number,
          name: string
        }
      }>,
      lastShipNominationStatus?: {
        __typename?: 'SimpleShipNominationStatusChangeShipPlanningDTO',
        id: number,
        status: {
          __typename?: 'ShipNominationStatusType',
          name: Types.ShipNominationStatus,
          color: string,
          languageKeyPrefix: string
        }
      } | null,
      voyages: Array<{
        __typename?: 'VoyageShipPlanningDTO',
        id: number,
        voyageNumber: string,
        salesCharterId?: number | null,
        lastStatusChange?: {
          __typename?: 'StatusChangeShipPlanningDTO',
          id: number,
          actualTime?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          callEstimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp: number,
          appliedBy: string,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'StatusWithSuccessiveStatusesShipPlanningDTO',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatusShipPlanningDTO',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescriptionShipPlanningDTO',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules: Array<{
              __typename?: 'StatusRuleShipPlanningDTO',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              type: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'StatusRuleTargetStatusShipPlanningDTO',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatusShipPlanningDTO',
                  enabled: boolean
                } | null
              }
            }>,
            confirmMessages?: {
              __typename?: 'LanguageDescriptionShipPlanningDTO',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            successiveStatuses: Array<{
              __typename?: 'StatusShipPlanningDTO',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatusShipPlanningDTO',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescriptionShipPlanningDTO',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules: Array<{
                __typename?: 'StatusRuleShipPlanningDTO',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                type: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'StatusRuleTargetStatusShipPlanningDTO',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatusShipPlanningDTO',
                    enabled: boolean
                  } | null
                }
              }>,
              confirmMessages?: {
                __typename?: 'LanguageDescriptionShipPlanningDTO',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null
            }>
          },
          supplier?: {
            __typename?: 'RelationShipPlanningDTO',
            id: number,
            name: string
          } | null
        } | null,
        from?: {
          __typename?: 'LocationShipPlanningDTO',
          id: number,
          description: string
        } | null,
        to?: {
          __typename?: 'LocationShipPlanningDTO',
          id: number,
          description: string
        } | null,
        ship: {
          __typename?: 'VoyageShipShipPlanningDTO',
          id: number,
          name: string,
          defaultCharterSubtype?: Types.CharterSubtype | null,
          operator?: {
            __typename?: 'RelationShipPlanningDTO',
            id: number,
            name: string,
            isApplicationRelation: boolean
          } | null,
          owner?: {
            __typename?: 'RelationShipPlanningDTO',
            id: number,
            name: string,
            isApplicationRelation: boolean
          } | null
        },
        calls: Array<{
          __typename?: 'CallShipPlanningDTO',
          id: number,
          pta: number,
          atd?: number | null,
          location: {
            __typename?: 'LocationShipPlanningDTO',
            description: string,
            type: Types.LocationType,
            locationGroups?: Array<{
              __typename?: 'LocationShipPlanningDTO',
              description: string,
              type: Types.LocationType
            }> | null
          }
        }>
      }>,
      debtor: {
        __typename?: 'RelationShipPlanningDTO',
        id: number,
        name: string,
        isApplicationRelation: boolean
      },
      broker?: {
        __typename?: 'RelationShipPlanningDTO',
        id: number,
        name: string,
        isApplicationRelation: boolean
      } | null,
      contacts?: Array<{
        __typename?: 'CharterContactShipPlanningDTO',
        contactRoleType: Types.ContactRoleType,
        contact: {
          __typename?: 'ContactShipPlanningDTO',
          id: number,
          name?: string | null,
          email?: string | null
        }
      }> | null,
      contract?: {
        __typename?: 'SalesContractShipPlanningDTO',
        agreements: Array<{
          __typename?: 'AgreementBaseShipPlanningDTO',
          type: Types.AgreementTypeEnum
        } | {
          __typename?: 'ShipAgreementShipPlanningDTO',
          type: Types.AgreementTypeEnum,
          ships: Array<{
            __typename?: 'ShipAgreementShipShipPlanningDTO',
            id: number,
            name: string
          }>
        }>
      } | null
    }>
  }
};


export const ShipPlanningOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"shipPlanningOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipPlanning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastContact"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"course"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"locationEntered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"callTimesPlanningFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"salesCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShipLinkDialogSalesCharterPlanning"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salesCharterStatusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalNotes"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nominatedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CargoServicesPlanning"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangePlanningFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionCallTimesPlanningFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"terminalPlanningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocationPlanning"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocationPlanning"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastTerminalContactDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"terminalPlanningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocationPlanning"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocationPlanning"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastTerminalContactDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipNominationStatusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastShipNominationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangePlanningFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salesCharterId"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCharterSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactRoleType"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"callTimesPlanningFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NextShipCallShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShipLinkDialogSalesCharterPlanning"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharterShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocationPlanning"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocationPlanning"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateOrSelectCharterFormCargoPlanning"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShipAgreementShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocationPlanning"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateOrSelectCharterFormCargoPlanning"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CargoServicesPlanning"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHoseRentalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isInhibitedProduct"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenBlanketingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenPurgingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isTemperatureControlRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isCleaningRequired"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangePlanningFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChangeShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"callEstimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragmentPlanning"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragmentPlanning"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusWithSuccessiveStatusesShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusBasePlanning"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusBasePlanning"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionCallTimesPlanningFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoActionCallShipPlanningDTO"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}}]}}]} as unknown as DocumentNode<ShipPlanningOverviewSubscription, ShipPlanningOverviewSubscriptionVariables>;